





























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  DefaultScreenSaver,
  FallbackScreenSaver,
  ScreenSaverType,
  ScreenSaverData,
  CampaignMedia,
  isDefaultScreenSaver,
  isFallbackScreenSaver,
} from '@/app/shared/utilities/static-types';
import ViewScreenSaver from './ViewScreenSaver/ViewScreenSaver.vue';
import DeleteScreenSaver from './DeleteScreenSaver/DeleteScreenSaver.vue';
import BlockingProgress from '@/app/shared/components/BlockingProgress.vue';
import { applyToAllAdSpacesAction } from '@adSpaces/shared/actions';
import { convertAdSpaceListToMap, convertScreenSaverMediaListToMap } from '@/app/shared/utilities/helper-functions';
import { FirebaseAppFirestore } from '@/app/shared/firebase/firebase-app';
import { loadAdSpacesAction } from '@adminSchedules/shared/actions';
import PreviewThumbnail from '@campaigns/shared/components/PreviewThumbnail.vue';

@Component({
  name: 'ScreenSaverItem',
  components: {
    PreviewThumbnail,
    ViewScreenSaver,
    DeleteScreenSaver,
    BlockingProgress,
  },
})
export default class ScreenSaverItem extends Vue {
  @Prop() public screenSaver!: ScreenSaverData;
  @Prop() public screenSaverType!: ScreenSaverType;
  public showViewScreenSaver = false;
  public showDeleteScreenSaver = false;

  public activeChanged() {
    this.$emit('active-changed', this.screenSaver.ID);
  }

  public screenSaverDeleted() {
    this.$emit('screen-saver-deleted');
  }

  public get isRegularScreenSaver(): boolean {
    return this.screenSaverType === ScreenSaverType.SCREEN_SAVER;
  }

  public get isFallbackScreenSaver(): boolean {
    return this.screenSaverType === ScreenSaverType.FALLBACK_SCREEN_SAVER;
  }

  public get screenSaverTitle(): string {
    if (this.isFallbackScreenSaver) {
      return this.$t('fallback_screen_saver').toString() + ` #${this.screenSaver.ORDER}`;
    }
    return this.$t('screen_saver').toString() + ` #${this.screenSaver.ORDER}`;
  }

  public get previewMedia(): CampaignMedia | null {
    if (isFallbackScreenSaver(this.screenSaver)) {
      return this.screenSaver.MEDIA_FILE;
    }
    if (isDefaultScreenSaver(this.screenSaver) && this.screenSaver.MEDIA_LIST.length > 0) {
      return this.screenSaver.MEDIA_LIST[0];
    }
    return null;
  }

  public get mediaCount(): number {
    if (isFallbackScreenSaver(this.screenSaver)) {
      return 1;
    }
    if (isDefaultScreenSaver(this.screenSaver)) {
      return this.screenSaver.MEDIA_LIST.length;
    }
    return 0;
  }
  public async applyScreenSaverToAllAdSpaces() {
    (this.$refs.progress as BlockingProgress).show();
    try {
      const adSpaces = await loadAdSpacesAction();

      const batch = FirebaseAppFirestore.batch();
      const screenSaverMap = convertScreenSaverMediaListToMap(
          (this.screenSaver as DefaultScreenSaver).MEDIA_LIST,
      );

      const adSpaceMap = convertAdSpaceListToMap(adSpaces);
      Object.entries(screenSaverMap).forEach(
          ([screenDimension, screenSaverMedia]) => {
            const adSpacesMatchesResolution = adSpaceMap[screenDimension];
            adSpacesMatchesResolution.forEach((adSpace) => {
              applyToAllAdSpacesAction(
                  batch,
                  adSpace,
                  (this.screenSaver as DefaultScreenSaver),
                  screenSaverMedia,
              );
            });
          },
      );

      await batch.commit();
    } finally {
      (this.$refs.progress as BlockingProgress).hide();
    }
  }
}
